import { FormInstance } from "antd";
import { useWatch } from "antd/es/form/Form";
import React from "react";
import CheckBoxList from "../../commons/components/CheckBoxList/CheckBoxList";
import CustomInput from "../../commons/components/CustomInput/CustomInput";
import { numberInputOnWheelPreventChange } from "../../commons/utils/functions/helper";
import { filterECharacterInputNumber, integerOnlyInput } from "../../commons/utils/functions/integerOnly";
import removeExtraSpace from "../../commons/utils/functions/removeExtraSpace";
import { isPositiveNumber } from "../../commons/utils/functions/validation";
import styles from "./styles.module.scss";

declare interface Props {
  inputName: string;
  checkBoxName: string;
  form: FormInstance;
  message: string;
  disabled?: boolean;
}

const InputBulkOrder: React.FC<Props> = ({ form, inputName, checkBoxName, message, disabled = false }) => {
  return (
    <div className={styles.inputItem}>
      <div>
        <CustomInput
          label={checkBoxName}
          name={inputName}
          disabled={disabled}
          onBlur={e => {
            removeExtraSpace(inputName, form);
          }}
          onWheel={numberInputOnWheelPreventChange}
          placeholder="Enter number"
          onKeyDown={integerOnlyInput}
          onChange={event => {
            filterECharacterInputNumber(inputName, form, event);
            form.validateFields();
          }}
          rules={[
            { validator: isPositiveNumber(inputName, message) },
            {
              required: false,
              message: "This field is required",
            },
          ]}
          allowClear
        />
      </div>
    </div>
  );
};

export default InputBulkOrder;
